import * as React from "react";
import {db} from "../../firebase";
import {withAuthorization} from "../../firebase/withAuthorization";
import {Button, Header, Modal, Label, Icon} from 'semantic-ui-react'
import {CategoryUpdateForm} from "../../pills/categories/categoryUpdateForm";
import {Link} from 'react-router-dom';
import {GifList} from "../../pills/gifs/gifList";
import {GifUpdateForm} from "../../pills/gifs/gifUpdateForm";
import {ICategoryDetailsProps} from "./ICategoryDetailsProps";
import {ICategoryDetailsState} from "./ICategoryDetailsState";
import {_} from "lodash"


class CategoryDetailsComponent extends React.Component<ICategoryDetailsProps, ICategoryDetailsState> {

    constructor(props) {
        super(props);

        this.state = {
            category: null,
            tags: null,
            modalDeleteOpen: false,
            modalUpdateOpen: false,
            categoryDeleted: false,
            modalUpdateGifOpen: false,
            modalDeleteGifOpen: false,
            currentGif: null,
            categoryGifs: null
        };

        this.handleUpdateCategory = this.handleUpdateCategory.bind(this)
        this.handleUpdateClose = this.handleUpdateClose.bind(this)
        this.handleOpenDeleteModal = this.handleOpenDeleteModal.bind(this)
        this.handleOpenUpdateModal = this.handleOpenUpdateModal.bind(this)
        this.handleCloseUpdateModal = this.handleCloseUpdateModal.bind(this)
        this.handleGifUpdated = this.handleGifUpdated.bind(this)

    }

    componentWillMount() {
        const id = window.location.pathname.split('/')[2]
        db.getCategoryById(id).then(snapshot => {
            const category = snapshot.val()
            console.log(id)

            console.log(category)
            category.id = id;

            this.setState({category: category})

            db.doGetGifsByCategory(category).then(res => res.json()).then(json => {
                const results = json.hits.hits
                const data = results.map(result => result._source)
                this.setState(() => ({categoryGifs: data}))
            })
                .catch(error => console.log(error))
        });
        db.onceGetTags().then(snapshot =>
            this.setState(() => ({tags: snapshot.val()}))
        );
    }

    handleCloseUpdateModal() {
        this.setState(() => ({
            modalUpdateGifOpen: false,
        }))
    }


    handleOpenDeleteModal(gif) {
        this.setState(() => ({
            modalDeleteGifOpen: true,
            currentGif: gif
        }))
    }

    handleOpenUpdateModal(gif) {
        this.setState(() => ({
            modalUpdateGifOpen: true,
            currentGif: gif
        }))
    }

    handleGifUpdated(currentGif) {
        this.setState(() => ({modalUpdateGifOpen: false}))
    }

    handleUpdateCategory(id) {
        db.getCategoryById(id).then(snapshot => {
            const category = snapshot.val()
            category.id = id;
            this.setState(() => ({
                category: category,
                modalUpdateOpen: false
            }))
        });
    }

    handleDeleteCategory() {
        const id = window.location.pathname.split('/')[2]
        db.doDeleteCategory(id).then(() => {
            console.log("Category Deleted")
        });
    }

    onDeleteGif(gif) {
        const {categoryGifs} = this.state;
        db.doDeleteGif(gif.id).then(() => {
            _.remove(categoryGifs, (item) => {
                return item.id === gif.id;
            });
            this.setState(() => ({categoryGifs: categoryGifs, modalDeleteGifOpen: false}))
        })
            .catch(error => console.log(error))
    }

    handleUpdateOpen = () => this.setState({modalUpdateOpen: true})

    handleDeleteOpen = () => this.setState({modalDeleteOpen: true})

    handleUpdateClose = () => this.setState({modalUpdateOpen: false})

    handleDeleteClose = () => this.setState({modalDeleteOpen: false})

    handleDeleteGifClose = () => this.setState({modalDeleteGifOpen: false})


    render() {
        const {
            category, modalDeleteOpen, modalUpdateOpen, tags,
            modalUpdateGifOpen, modalDeleteGifOpen, currentGif, categoryGifs
        } = this.state;
        return (
            <div>
                {!!category &&
                <div>
                    <Header as='h1' block>{category.name}
                        <Header.Subheader style={{float: 'right '}}>Priority :
                            {category.priority === 1 && " Top"}
                            {category.priority === 2 && " Medium"}
                            {category.priority === 3 && " Basic"} </Header.Subheader>
                        <Modal
                            open={modalUpdateOpen}
                            trigger={
                                <Button size='small' onClick={this.handleUpdateOpen} style={{marginLeft: '50px'}}
                                        primary>Update</Button>
                            }>
                            <Modal.Header>Update Category</Modal.Header>
                            <Modal.Content>
                                <CategoryUpdateForm category={category}
                                                    tags={tags}
                                                    onModalClosed={this.handleUpdateClose}
                                                    onCategoryUpdated={this.handleUpdateCategory}
                                />
                            </Modal.Content>
                        </Modal>
                        <Modal
                            open={modalDeleteOpen}
                            trigger={
                                <Button size='small' onClick={this.handleDeleteOpen} style={{marginLeft: '10px'}}
                                        negative>Delete</Button>
                            }>
                            <Modal.Header>Delete Category</Modal.Header>
                            <Modal.Content>
                                Are you sure you want to delete this category?
                            </Modal.Content>
                            <Modal.Actions>
                                <Button color='green' onClick={this.handleDeleteClose}>
                                    <Icon name='checkmark'/> No
                                </Button>
                                <Button as={Link} to={{pathname: '/categories'}} color='red'
                                        onClick={this.handleDeleteCategory}>
                                    <Icon name='remove'/> Yes
                                </Button>
                            </Modal.Actions>
                        </Modal>
                    </Header>
                    <div>
                        {Object.keys(category.tags).map(key => {
                            return (
                                <Label key={key} as='a' tag>
                                    {category.tags[key].text}
                                </Label>)
                        })
                        }
                    </div>
                    <div>
                        <Modal
                            open={modalUpdateGifOpen}>
                            <Modal.Header>Update Gif</Modal.Header>
                            <Modal.Content>
                                <GifUpdateForm onGifUpdated={this.handleGifUpdated}
                                               handleCloseModal={this.handleCloseUpdateModal} currentGif={currentGif}
                                               tags={tags}/>
                            </Modal.Content>
                        </Modal>
                        <Modal
                            open={modalDeleteGifOpen}>
                            <Modal.Header>Delete Gif</Modal.Header>
                            <Modal.Content>
                                Are you sure you want to delete this Gif?
                            </Modal.Content>
                            <Modal.Actions>
                                <Button color='green' onClick={this.handleDeleteGifClose}>
                                    <Icon name='remove'/> No
                                </Button>
                                <Button color='red' onClick={() => this.onDeleteGif(currentGif)}>
                                    <Icon name='checkmark'/> Yes
                                </Button>
                            </Modal.Actions>
                        </Modal>
                        <br/>
                        {!!categoryGifs &&
                        <GifList handleDelete={this.handleOpenDeleteModal} handleUpdate={this.handleOpenUpdateModal}
                                 gifs={categoryGifs}/>
                        }
                    </div>
                </div>
                }
            </div>
        )
    }
}

const authCondition = (authUser) => !!authUser;

export const CategoryPage = withAuthorization(authCondition)(CategoryDetailsComponent);



// WEBPACK FOOTER //
// ./src/pages/CategoryDetails/index.tsx